import React, {useState} from 'react';
import TextBox from '../components/textbox';
import ButtonComp from '../components/button';
import '../styling/containerStyles.css';
import Label from '../components/label';
import Button from '@material-ui/core/Button';
import leftChevron from '../assets/images/leftChevron.svg';


interface VerifyOtpProps{
    handleToUpdateOtp:Function;
    msg:string;
    banner: any;
    subBanner: any;
}

export const VerifyOtp: React.FC<VerifyOtpProps> = (props: VerifyOtpProps) =>{

    const{
        handleToUpdateOtp, msg, banner, subBanner
    } = props;

    const [otp, setOtp] = useState('')
    const [message, setMessage] = useState(msg)

    const handleToUpdateContent = (name:string, arg:string) => {       
        if(name === 'otp'){
            setOtp(arg)
        }                
    }

    const handleToUpdateOTP = (arg:string) => {
        var re = /^[0-9]{4}$/;
        if(re.test(otp) )
            handleToUpdateOtp(otp)
        else{
            setMessage('Please enter a valid OTP')
            setOtp('')
        }
        
    }

        return (
            <div className='homeWrap section-space-between'>
                <div className='homeTop'>
                    <div className='homeTopBanner'>
                        <img src={banner} alt='Pidilite Top Banner' className='pidiliteTopBanner'/>
                    </div>
                </div>
                <div className='home home-verify-number'>
                    
                    <div className='verifyNumberPage'>                  
                    <div className='productImageWrap'>
                        <img src={subBanner} alt='Product Image' className='productImage'/>
                    </div>
                        <div className='buttonAndLabel'>
                            <Button className='goBack back-btn' 
                            // onClick={() => {handleToUpdateOtp('GoBack')}}
                             >
                                <img src={leftChevron} alt='Left Chevron' className='leftChevron'/>
                            </Button> 
                            <Label content='OTP has been sent to your mobile number' />
                        </div>
                        <br></br>
                        <div className='verifyOTP'>

                            <TextBox className='textBox'
                                    label={'Enter OTP'} 
                                    state={'otp'}
                                    placeholder={'Eg: 1234'} 
                                    handleToUpdate={handleToUpdateContent} 
                                    />
                                    
                            <div className='message'>{message}</div>

                            <ButtonComp label= {'Enter OTP'} 
                                    name={'VERIFY MOBILE NUMBER'} 
                                    visible={true}
                                    handleToUpdate={handleToUpdateOTP}  />
                        </div>

                    </div>   

                </div>
            </div>             
        )
    }

export default VerifyOtp